import { AutoComplete } from '../../../components/AutoComplete';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useSelectStyles } from '../../../components/Filters/selectStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.palette.mapInfoSection,
    '&.MuiAutocomplete-root .MuiInputLabel-root': {
      paddingTop: '2px',
    },
    '&.MuiAutocomplete-root .MuiFilledInput-root > input': {
      padding: '24px 4px 10px',
    },
  },
}));

export default ({ displayedItem, loading, data, onChange }) => {
  const classes = useStyles();
  const selectClasses = useSelectStyles();

  if (!displayedItem || loading || !data || !data.asset || !(data.asset.assetModels.length > 0)) {
    return null;
  }

  const { assetModels, baseName } = data.asset;
  const assetModel = assetModels.find((assetModel) => assetModel.name === displayedItem.name);

  if (!assetModel) {
    return null;
  }

  return (
    <div className={classes.root}>
      <AutoComplete
        styles={selectClasses}
        getData={null}
        menuItems={assetModels}
        onChange={(value) => {
          onChange({
            ...value,
            type: 'asset',
          });
        }}
        value={assetModel}
        label={`${baseName} Models`}
        optionKey="displayName"
        runQueryAfterOnChange={false}
        queryVariable={null}
        multiple={false}
      />
    </div>
  );
};
